import React from "react";
import MediaQuery from "react-responsive";
import background from "./background.png";
import aboutusfg from "./aboutusfg.png";

const AboutUs = ( {language} ) => {
  return (
    <div>
      <MediaQuery maxWidth={412}>
        <div className="relative border-gray-100 border-2 rounded-sm flex flex-col gap-0 py-20">
          <div className="flex justify-center items-start">
            <img
              src={background}
              alt="background"
              className="relative flex flex-wrap justify-center pt-2 object-contain"
            />
            <img
            src={aboutusfg}
            alt="about us"
            className="absolute inset-0 object-contain w-full h-full py-20 lg:w-1/2 pr-40 lg:pr-0 lg:pl-10 md:pr-60"
            style={{ left: "80px", top: "-130px" }}
          />
          </div>
          <div
            className="flex flex-col text-2xl sm:bottom-0 sm:top-20 sm:right-12 md:top-32 right-2 bottom-14 lg:right-32 lg:gap-4 lg:top-44 gap-2 xl:right-40 text-center xl:top-56 scale-75 top-4 justify-center"
          >
            {language === 'en' && (
            <p className="relative font-bold text-4xl sm:text-2xl sm:left-6 md:text-2xl lg:text-4xl xl:text-4xl left-0 md:left-8 mb-4 lg:left-20 xl:pb-4">
              About Us
            </p>
            )}
            {language === 'hi' && (
            <p className="relative font-bold text-4xl sm:text-2xl sm:left-6 md:text-2xl lg:text-4xl xl:text-4xl left-0 md:left-8 mb-4 lg:left-20 xl:pb-4">
              हमारे बारे में
            </p>
            )}
            {language === 'en' && (
            <p className="w-[95%] text-lg text-justify">
              We, Sthapna situated at Sodala, Jaipur, Rajasthan believe, good
              design is produced from careful study and research, combined with
              technical knowledge and artistic judgement. It is our aim to
              create spaces were people & activities thrive. Our team is capable
              in handling all the projects from the initial concept till the
              actual completion of the whole project.
            </p>
            )}
            {language === 'hi' && (
            <p className="w-[95%] text-lg text-justify">
              हम, स्थापना सोडाला, जयपुर, राजस्थान स्थित हैं, मानते हैं कि अच्छी डिज़ाइन का अध्ययन 
              और शोध के माध्यम से किया जाता है, तकनीकी ज्ञान और कला से सम्पन्न मूल्यांकन के साथ 
              मिलकर उत्पन्न होता है। हमारा लक्ष्य है कि हम ऐसे स्थानों का निर्माण करें जहां लोग और 
              गतिविधियाँ सफलतापूर्वक विकसित हों। हमारी टीम प्रोजेक्ट की प्रारंभिक धारणा से लेकर पूरे 
              परियोजना के वास्तविक पूर्णता तक की सभी कार्यों को संभालने में सक्षम है।
            </p>
            )}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery minWidth={413}>
        <div className="relative border-gray-100 border-2 rounded-sm">
          <img
            src={background}
            alt="background"
            className="relative flex flex-wrap justify-center pt-2"
          />
          <img
            src={aboutusfg}
            alt="about us"
            className="absolute inset-0 object-contain w-full h-full lg:w-1/2 pr-40 lg:pr-0 lg:pl-10 md:pr-60"
            style={{ left: "-30px", top: "10px" }}
          />
          <div
            className="absolute text-sm right-4 sm:right-2 sm:bottom-0 sm:top-20 sm:right-12 md:top-32 right-2 bottom-14 lg:right-32 lg:gap-4 lg:top-44 gap-2 xl:right-60 text-center xl:top-56 scale-100 top-4"
            style={{ left: "50%" }}
          >
            {language === 'en' && (
            <p className="relative font-bold text-3xl sm:text-2xl sm:left-6 md:text-2xl lg:text-4xl xl:text-4xl left-3 md:left-8 mb-4 lg:left-14 xl:pb-4">
              About Us
            </p>
            )}
            {language === 'hi' && (
            <p className="relative font-bold text-3xl sm:text-2xl sm:left-6 md:text-2xl lg:text-4xl xl:text-4xl left-3 md:left-8 mb-4 lg:left-20 xl:pb-4">
              हमारे बारे में
            </p>
            )}
            {language === 'en' && (
            <p className="lg:w-[120%] text-lg text-justify pt-6">
              We, Sthapna situated at Sodala, Jaipur, Rajasthan believe, good
              design is produced from careful study and research, combined with
              technical knowledge and artistic judgement. It is our aim to
              create spaces were people & activities thrive. Our team is capable
              in handling all the projects from the initial concept till the
              actual completion of the whole project.
            </p>
            )}
            {language === 'hi' && (
            <p className="lg:w-[120%] text-lg text-justify pt-6">
              हम, स्थापना सोडाला, जयपुर, राजस्थान स्थित हैं, मानते हैं कि अच्छी डिज़ाइन का अध्ययन 
              और शोध के माध्यम से किया जाता है, तकनीकी ज्ञान और कला से सम्पन्न मूल्यांकन के साथ 
              मिलकर उत्पन्न होता है। हमारा लक्ष्य है कि हम ऐसे स्थानों का निर्माण करें जहां लोग और 
              गतिविधियाँ सफलतापूर्वक विकसित हों। हमारी टीम प्रोजेक्ट की प्रारंभिक धारणा से लेकर पूरे 
              परियोजना के वास्तविक पूर्णता तक की सभी कार्यों को संभालने में सक्षम है।
            </p>
            )}
            
          </div>
        </div>
      </MediaQuery>
    </div>
  );
};

export default AboutUs;
